import { twMerge } from 'tailwind-merge';
export const TitleBattlePass = ({ className, description }) => {
    return (<div className={twMerge('flex flex-col justify-center items-center', className)}>
			<h1 className="text-light-4 text-2xl upper font-mono my-2 font-medium text-center">{description}</h1>
			<p className="font-medium font-mono text-center">CLAIM THE TOP REWARDS AND PROVE YOU’RE READY FOR THE NEXT LEVEL</p>
		</div>);
};
